<template>
	<div class="onlineservice" v-if="isShow1">
		<div class="top">
			<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/xiaodongxiao02.gif" alt="" />
			<div class="xianzai">
				<p>现在就与君和客服在线沟通</p>
				<span class="phone">客服热线：</span>
				<!-- <span class="tel">400-039-7699</span> -->
				<span class="tel">15617622505</span>
			</div>
		</div>
		<div class="bottom">
			<!-- <button @click="toConsult">在线咨询</button> -->
			<a onclick="openZoosUrl('chatwin')">在线咨询</a>
		</div>
		<img class="x" @click="close1" src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/x.png" alt="" />
	</div>
</template>

<script>
	export default {
		name: "Onlineservice",
		data() {
			return {
				isShow1: false,
			};
		},
		mounted() {
			setTimeout(() => {
				this.isShow1 = true;
			}, 3000);
		},
		methods: {
			close1() {
				this.isShow1 = false;
			},
			toConsult() {
				window.open(
					"https://wt.zoosnet.net/LR/Chatpre.aspx?id=LRW51906172&lng=cn&e=%e5%bc%b9%e7%aa%97",
					"_blank"
				);
			},
		},
	};
</script>

<style lang="less" scoped>
	.onlineservice {
		z-index: 999;
		overflow: hidden;
		position: fixed;
		bottom: 20px;
		left: 10px;
		width: 450px;
		height: 200px;
		background-color: #f2f5fb;
		box-shadow: 0px 2px 8px 2px rgba(0, 0, 0, 0.2);

		.top {
			margin-top: 10px;
			height: 100px;
			width: 100%;
			display: flex;
			justify-content: space-around;
			align-items: center;

			img {
				display: block;
				width: 120px;
				height: 120px;
				border-radius: 50%;
				margin-left: -20px;
			}

			.xianzai {
				margin-left: -60px;

				p {
					width: 270px;
					height: 30px;
					font-size: 20px;
					font-weight: 500;
					color: #999999;
					line-height: 30px;
				}

				.phone {
					width: 270px;
					height: 30px;
					font-size: 20px;
					font-weight: 500;
					color: #999999;
					line-height: 30px;
				}

				.tel {
					width: 270px;
					height: 30px;
					font-size: 22px;
					font-weight: 600;
					color: #fe0000;
					line-height: 30px;
				}
			}
		}

		.bottom {
			width: 100%;
			height: 100px;

			button {
				display: block;
				width: 178px;
				height: 50px;
				background: #fe0808;
				box-shadow: 10px 17px 20px 0px rgba(254, 8, 8, 0.1),
					0px 2px 0px 0px #ffffff;
				border-radius: 3px;
				font-size: 20px;
				font-weight: 800;
				color: #ffffff;
				line-height: 30px;
				margin: 10px auto;
				text-align: center;
			}

			a {
				display: block;
				width: 178px;
				height: 50px;
				background: #fe0808;
				box-shadow: 10px 17px 20px 0px rgba(254, 8, 8, 0.1),
					0px 2px 0px 0px #ffffff;
				border-radius: 3px;
				font-size: 20px;
				font-weight: 800;
				color: #ffffff;
				line-height: 50px;
				margin: 10px auto;
				text-align: center;
			}
		}

		.x {
			display: block;
			position: absolute;
			width: 26px;
			height: 26px;
			top: 8px;
			right: 8px;
		}

		.x:hover {
			cursor: pointer;
		}
	}
</style>